import { USER_ROLES } from '@/api/user';

export default {
  payload: (state) => {
    const payload = Object.assign({}, state.item);
    payload.role = USER_ROLES.USER;
    return payload;
  },
};
